import { Badge } from '@kerfjs/ui/badge';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import type { SafeHtml } from 'kerfjs';
import { MessageSquare } from 'lucide';

/** A line's note count beside its status markers, shown only once it has notes (HS2-JRQT8A). */
export function LineNoteCount({ count }: { count: number }): SafeHtml {
  if (count === 0) return <></>;
  return (
    <Badge
      tone="neutral"
      shape="pill"
      size="compact"
      icon={<LucideIcon icon={MessageSquare} name="" />}
      label={`${String(count)} note${count === 1 ? '' : 's'}`}
      rootAttributes={{ 'data-line-note-count': String(count) }}
    >
      {count}
    </Badge>
  );
}
